<i18n src="@/common/i18n/i18n-locales.json"></i18n>

<template>
  <div>
    <template
      v-for="(itemObjs, index) in Object.keys(cart).map(k => cart[k])">
      <transition-group
        name="item-card-list"
        :key="`your-order-item-${index}`">
        <item-card
          v-for="(item, key, index) in itemObjs"
          :key="`your-order-item-${key}`"
          :itemObj="item"
          :itemIndex="parseInt(index)"
          class="item-card">
        </item-card>
      </transition-group>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ItemCard from '../components/ItemCard'

export default {
  name: 'Order',
  computed: {
    ...mapState('itemModule', [ 'cart' ])
  },
  components: {
    ItemCard
  }
}
</script>

<style lang="scss" scoped>
.meal-information {
  font-size: 14px;
  margin: 5px 15px;
}

.item-card-list-enter-active, .item-card-list-leave-active {
  // transition: all 1s;
  // position: absolute; /* 這個部分會讓動畫變得怪怪的，但是不加就會變得很卡 */
}
.item-card-list-enter, .item-card-list-leave-to {
  opacity: 0;
  transform: translate(100px, 0px);
}
.item-card {
  transition: all 0.5s;
}
</style>
